<!--comments-->
<mat-card
    class="daxa-card recent-orders-card  border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined" style="font-size: medium;">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un bons de commande..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-outline-primary btn-sm rounded-pill border-0" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-arrow-down-short-wide px-3"></i>
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
              <div *ngIf="pdfPreviewUrl; else tableView" class="mt-4">
                <h3>Aperçu du devis</h3>
                <iframe [src]="pdfPreviewUrl | safe" width="100%" height="800px" frameborder="0"></iframe>
              </div>
              <ng-template #tableView>
              <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

                <!-- select Column -->
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="handleSelectAll()" [checked]="isAllBonsCommandeSelected"/>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="isAllBonsCommandeSelected" (change)="handleSelection(element)"/>
                  </td>
                </ng-container>
                <ng-container matColumnDef="numeroBonsCommande">
                  <th mat-header-cell *matHeaderCellDef> Référence </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.numeroBonsCommande }}
                  </td>
                </ng-container>
                                    
                <!-- Date de création -->
                <ng-container matColumnDef="dateCreation">
                  <th mat-header-cell *matHeaderCellDef> Date de création </th>
                  <td mat-cell *matCellDef="let element"> {{ element.dateCreation | date }} </td>
                </ng-container>
              

              
                <!-- Date de livraison -->
                <ng-container matColumnDef="dateLivraison">
                  <th mat-header-cell *matHeaderCellDef> Date de livraison </th>
                  <td mat-cell *matCellDef="let element"> {{ element.dateLivraison | date }} </td>
                </ng-container>
              
                <!-- Délai de livraison -->
                <ng-container matColumnDef="delaiLivraison">
                  <th mat-header-cell *matHeaderCellDef> Délai livraison </th>
                  <td mat-cell *matCellDef="let element"> {{ element.delaiLivraison }} jours</td>
                </ng-container>
              
                <!-- Méthode d'expédition -->
                <ng-container matColumnDef="methodeExpedition">
                  <th mat-header-cell *matHeaderCellDef> Méthode expédition </th>
                  <td mat-cell *matCellDef="let element"> {{ element.methodeExpedition }} </td>
                </ng-container>
              
                <!-- Condition de règlement -->
                <ng-container matColumnDef="conditionReglement">
                  <th mat-header-cell *matHeaderCellDef> Condition de règlement </th>
                  <td mat-cell *matCellDef="let element"> {{ element.conditionReglement }} </td>
                </ng-container>
              
                <!-- Total HT -->
                <ng-container matColumnDef="totalHT">
                  <th mat-header-cell *matHeaderCellDef> Total HT </th>
                  <td mat-cell *matCellDef="let element"> {{ element.totalHT | number:'1.2-2' }} MAD</td>
                </ng-container>
              
                <!-- Total TTC -->
                <ng-container matColumnDef="totalTTC">
                  <th mat-header-cell *matHeaderCellDef> Total TTC </th>
                  <td mat-cell *matCellDef="let element"> {{ element.totalTTC | number:'1.2-2' }} MAD</td>
                </ng-container>
              
                <!-- Client 
                <ng-container matColumnDef="clientNom">
                  <th mat-header-cell *matHeaderCellDef> Client </th>
                  <td mat-cell *matCellDef="let element"> {{ element.clientNom }} </td>
                </ng-container>
-->

  <!-- Type d'analyse -->
  <ng-container matColumnDef="typeAnalyseNom">
    <th mat-header-cell *matHeaderCellDef> Type d'analyse </th>
    <td mat-cell *matCellDef="let element">
      <ng-container *ngFor="let detail of element.details">
        {{ detail.typeAnalyseNom }} <br />
      </ng-container>
    </td>
  </ng-container>
<ng-container matColumnDef="action">
  <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
  <td mat-cell *matCellDef="let element">
      <div class="action-info text-center" style="justify-content: center !important;">
        <button type="button" mat-button matTooltip="Télécharger PDF" matTooltipPosition="above" 
        (click)="generateDevis(element.id)">
        <i class="fa-solid fa-file-pdf text-success"></i>

    </button>
    

      
          <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                  (click)="openEditModal(element,editModal)">
              <i class="material-symbols-outlined text-primary">
                  brush
              </i>
          </button>
          <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                  (click)="confirmDelete(element)">
              <i class="material-symbols-outlined text-danger">
                  delete
              </i>
          </button>
      </div>
  </td>
</ng-container>

              
                <!-- Table Header and Rows -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              
              </table>
             </ng-template>
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

        </div>

    </mat-card-content>
</mat-card>

<ng-template #content let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
          <h5 class="mt-0 mb-0">Nouvelle proposition de devis</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="Form" (ngSubmit)="saveDevis()">
          <div class="row g-3">
            <!-- Référence du devis 
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Référence</mat-label>
                <input matInput formControlName="numeroDevis" placeholder="Ex. DEV-1234">
                <mat-error *ngIf="Form.get('numeroDevis')?.hasError('required')">La référence est requise</mat-error>
              </mat-form-field>
            </div>-->
            <div class="col-sm-6">
              <mat-checkbox formControlName="tvaApplicable">
                Ne Pas Appliquer la TVA
              </mat-checkbox>
            </div>
            
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Client</mat-label>
                <mat-select formControlName="clientId">
                  <mat-option *ngFor="let client of clients" [value]="client.id">
                    {{ client.socialReason }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="Form.get('clientId')?.hasError('required')">Le client est requis</mat-error>
              </mat-form-field>
            </div>
        
            <div class="col-sm-6" *ngFor="let field of ['dateCreation', 'dateExpiration', 'dateLivraison']">
              <mat-form-field class="full-width">
                <mat-label>
                  {{ field === 'dateCreation' ? 'Date de création' : 
                     field === 'dateExpiration' ? 'Date d\'expiration' : 
                     field === 'dateLivraison' ? 'Date de livraison' : field }}
                </mat-label>
                <input matInput type="date" [formControlName]="field">
                <mat-error *ngIf="Form.get(field)?.hasError('required')">Ce champ est requis</mat-error>
              </mat-form-field>
            </div>
        

        
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Délai de livraison après commande</mat-label>
                <input matInput type="number" formControlName="delaiLivraison" min="1">
                <mat-error *ngIf="Form.get('delaiLivraison')?.hasError('required')">Ce champ est requis</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <mat-label>Durée de validité</mat-label>
                <input matInput formControlName="validite" placeholder="Ex. 30 jours">
                <mat-error *ngIf="Form.get('validite')?.hasError('required')">La durée de validité est requise</mat-error>
              </mat-form-field>
            </div>

        
            <div class="col-sm-6" *ngFor="let field of ['methodeExpedition', 'conditionReglement']">
              <mat-form-field class="full-width">
                <mat-label>{{ field === 'methodeExpedition' ? 'Méthode d\'expédition' : 'Condition de règlement' }}</mat-label>
                <textarea matInput [formControlName]="field" rows="4"></textarea>
                <mat-error *ngIf="Form.get(field)?.hasError('required')">Ce champ est requis</mat-error>
              </mat-form-field>
            </div>
        

            <div [formGroup]="detailForm" class="row g-3">
              <div class="d-flex align-items-center g-3">
                <div class="col-sm-4">
                  <mat-form-field class="full-width">
                    <mat-label>Type d'Analyse</mat-label>
                    <mat-select formControlName="typeAnalyseId" (selectionChange)="onTypeAnalyseChangex()">
                      <mat-option *ngFor="let typeAnalyse of typeAnalyses" [value]="typeAnalyse.id">
                        {{ typeAnalyse.codeAT }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="detailForm.get('typeAnalyseId')?.hasError('required')">Requis</mat-error>
                  </mat-form-field>
                </div>
              
                <div class="col-sm-4 ms-3">
                  <mat-form-field class="full-width">
                    <mat-label>Quantité</mat-label>
                    <input matInput type="number" formControlName="qte" min="1">
                    <mat-error *ngIf="detailForm.get('qte')?.hasError('required')">Requis</mat-error>
                  </mat-form-field>
                </div>
              
                <div class="col-sm-3 ms-3">
                  <mat-form-field class="full-width">
                    <mat-label>Prix Unitaire</mat-label>
                    <input matInput type="number" formControlName="prixUnitaire" readonly>
                    <mat-error *ngIf="detailForm.get('prixUnitaire')?.hasError('required')">Requis</mat-error>
                  </mat-form-field>
                </div>
              
                <div class="col-sm-1 d-flex align-items-center ms-1" >
                  <button type="button" mat-button matTooltip="Ajouter" matTooltipPosition="above"
                  (click)="addDetailx()" >
                  <i class="material-symbols-outlined text-primary" style="font-size: 30px;">
                    add
                  </i>
          </button>
                </div>
                
                
              </div>
            </div>
            <table class="table table-striped table-bordered mt-4" *ngIf="detailsList.length > 0">
              <thead class="table-light">
                <tr>
                  <th>Type d'Analyse</th>
                  <th>Description</th>
                  <th>Quantité</th>
                  <th>Prix Unitaire</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let d of detailsList; let i = index">
                  <td>{{ getTypeAnalyseName(d.typeAnalyseId) }}</td>
                  <td>{{ getTypeAnalyseDesc(d.typeAnalyseId) }}</td>
                  <td>{{ d.qte }}</td>
                  <td>{{ d.prixUnitaire }}</td>
                  <td>
                    <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="removeDetailx(i)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-right mt-3">
              <button mat-raised-button color="primary" type="submit">Créer le Devis</button>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
</ng-template>


<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>



